import styled from "styled-components";
import HalfCircleProgress from "../molecules/HalfCircleProgress";

const Wrap = styled.article`
    width: 432px;

    > .h2 {
        > span {
            margin-left: 10px;
            color: #00b081;
        }
    }
    .ribbon-graph {
        margin-top: 26px;
        flex-shrink: 0;
    }
    .row-wrap.chart-wrap {
        justify-content: space-between;
        margin-top: 16px;
    }
    .desc {
        margin-top: 8px;
        color: #000;
    }
    > section {
        margin-top: 8px;
        .solution-list {
            padding: 0;
            margin-top: 12px;
            margin-bottom: 0;

            li {
                font-size: 10px;
                color: #848484;

                & ~ li {
                    margin-top: 6px;
                }
            }
        }
    }
`
export default function SkinAging({data}) {
    return (
        <Wrap className="skin-aging">
            <div className="h2">
                피부 노화 정도<span className="lv">LV.{data.skin_aging.level}</span>
            </div>

            <div className="ribbon-graph">
                {Array(6).fill(0).map((val, idx) => {
                    return (
                        <div key={idx} className={idx <= data.skin_aging.level ? "fill" : ""}>
                            {idx}

                            {idx == data.skin_aging.level && (
                                <div className="tooltip">
                                    <span>{data.skin_aging.score}</span>점
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>

            <section>
                <h6 className="body2">노화에 영향을 주는 주요 원인</h6>

                <div className="row-wrap chart-wrap">
                    {data.skin_aging.factor_list.map((val, idx) => {
                        return (
                            <HalfCircleProgress key={"chart_" + idx} name={val.typeName} value={val.score}/>
                        )
                    })}
                </div>
            </section>
            
            <p className="desc">
                레벨이 낮을수록 노화 진행 속도가 더딤을 ​의미하고, 
                <br/>점수는 높을수록 좋은 상태를 의미합니다.
            </p>
        </Wrap>
    )
}